const ApplicationTypes = {
  IKnow: 'itemStudy',
  SentenceTrainer: 'sentenceStudy',
  RapidChoice: 'rapidChoice',
  SelfAssessment: 'selfAssessment',
  Listening: 'listening',
};

const ItemApplicationTypes = [
  ApplicationTypes.IKnow,
  ApplicationTypes.RapidChoice,
  ApplicationTypes.SelfAssessment,
];

const SentenceApplicationTypes = [
  ApplicationTypes.SentenceTrainer,
  ApplicationTypes.Listening,
];

/**
 * Helper method to calculate totals.
 *
 * @param {String[]} applicationTypes    keys to use for lookups in iKnowCumulatives
 * @param {IKnowCumulatives} iKnowCumulatives
 * @returns {Number}
 */
function sumStudyTime(applicationTypes, iKnowCumulatives) {
  return applicationTypes.reduce((prev, applicationType) => {
    const cumulativeData = iKnowCumulatives[applicationType];
    const cumulativeTime = cumulativeData && cumulativeData.cumulativeStudyTimeMillis || 0;
    return prev + cumulativeTime;
  }, 0);
}

export default class IKnowCumulatives {
  constructor(attrs = {}) {
    _.defaults(this, attrs);
  }

  /**
   * Returns the total cumulative time across all application types.
   *
   * @returns {Number}
   */
  getTotalTime() {
    return this.getItemsTotalTime() + this.getSentencesTotalTime();
  }

  /**
   * Returns the total cumulative time across all item application types.
   *
   * @returns {Number}
   */
  getItemsTotalTime() {
    return sumStudyTime(ItemApplicationTypes, this);
  }

  /**
   * Returns the total cumulative time across all sentence application types.
   *
   * @returns {Number}
   */
  getSentencesTotalTime() {
    return sumStudyTime(SentenceApplicationTypes, this);
  }
}
